import {
  RepeatabilityMode,
  SBCRewardType,
} from "@/api/privateRequests/sbcs/getSbcSets";
import { Player } from "@repo/shared/types";

import axios from "../../api";

/**
 * An SBC set as the /trending feeds return it: the set list's own shape, with
 * the first reward lifted out and the platform price already picked.
 */
export type TrendingSBC = {
  id: number;
  name: string;
  slug?: string;
  imageURL: string;
  reward?: SBCRewardType;
  description: string;
  price: number;
  repeatable: boolean;
  repeats?: number;
  refreshInterval?: number;
  startTime: number;
  endTime: number;
  upVotes: number;
  downVotes: number;
  wasUpvoted?: boolean;
  wasDownvoted?: boolean;
  isNew: boolean;
  sbcsCount: number;
  solvedCount: number;
  repeatabilityMode: RepeatabilityMode;
  isFavorite: boolean;
  isHidden: boolean;
  hasRefreshed: boolean;
  pointsRequired?: number;
};

export const getTrendingPlayers = async (limit?: number): Promise<Player[]> => {
  const res = await axios.get<Player[]>(
    `/trending/players${limit ? `?limit=${limit}` : ""}`,
  );

  return res.data;
};

export const getTrendingSbcs = async (): Promise<any[]> => {
  const res = await axios.get<any[]>(`/trending/sbc-sets?limit=8`);

  const trendingSbcs = res.data.map((sbc) => {
    return {
      ...sbc,
      reward: sbc.rewards?.[0],
    };
  });
  return trendingSbcs;
};
